export default __webpack_public_path__ + "static/media/logoIITK.ef74e15f.svg";